module.exports = __webpack_public_path__ + "img/nav-about-movie@2x.baf67c4.jpg";